// extracted by mini-css-extract-plugin
export default {"header":"EditClientName_header__gOa-x","icon":"EditClientName_icon__-F6MM"};